import { connect } from "react-redux";
import { handleInviteSignUp, registerTeam } from "../../redux/auth/sessions/actions";
import realTeamSelection from "../auth/TeamSelection";

const TeamSelection = connect(
  state => ({
    dataLoading: state.ui.main.loading
  }),
  dispatch => ({
    handleInviteSignUp(payload, navigate, inviteSecret, callback) {
      return dispatch(handleInviteSignUp(payload, navigate, inviteSecret, callback));
    },
    registerTeam(payload, navigate) {
      return dispatch(registerTeam(payload, navigate));
    }
  })
)(realTeamSelection);

export default TeamSelection;
